export enum AppView {
  Map,
  Table,
  VoidGap
}
